<script setup lang="ts">
import { XButton, XIcon } from '@clicksign/excalibur';
import { useBreakpoints } from '@clicksign/excalibur/composables';

import { APP_ROUTES } from '~~core';

import { useSignupShortcut } from '../../composables/use-signup-shortcut';

export type FeedbackSuccessAccessDocumentsCTAProps = {
  hasAccount?: boolean,
  isFromSignerArea?: boolean,
};

const props = defineProps<FeedbackSuccessAccessDocumentsCTAProps>();

const { signupWithShortcut } = useSignupShortcut();

const { isMobile } = useBreakpoints();

const CTALink = computed(() => {
  if (!props.hasAccount) return signupWithShortcut.value;

  return `${APP_ROUTES.signerArea}?tab=signed`;
});

</script>

<template>
  <div :class="$style.ctaContainer">
    <XButton
      v-if="props.isFromSignerArea"
      data-testid="signerDashboardButton"
      design="link"
      external
      :to="APP_ROUTES.signerArea"
    >
      <XIcon
        icon="arrow-left"
        left
      />
      <span v-if="isMobile">
        {{ $t('requirement.feedback.signerAreaCTA.mobileCTA') }}
      </span>
      <span v-else>
        {{ $t('requirement.feedback.signerAreaCTA.desktopCTA') }}
      </span>
    </XButton>

    <XButton
      data-testid="accessDocumentsButton"
      design="link"
      external
      :to="CTALink"
    >
      <XIcon
        icon="eye"
        left
      />
      {{ $t('requirement.feedback.accessDocument') }}
    </XButton>
  </div>
</template>

<style lang="scss" module>
.ctaContainer {
  display: flex;
  align-items: center;
  flex-direction: column-reverse;

  @include breakpoint('medium') {
    justify-content: center;
    flex-direction: row;
    gap: var(--space-regular);
  }
}
</style>
